var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-invite.f430629c.png","uri@2x": __webpack_public_path__ + "icon-invite.f20f5cf3.png","uri@3x": __webpack_public_path__ + "icon-invite.1bca6d5f.png",
    width: 54,
    height: 42
});